import { FC } from 'react';
import { Badge } from '@lithos';

interface EnabledDisabledBadgeProps {
  enabled: boolean;
}

const EnabledDisabledBadge: FC<EnabledDisabledBadgeProps> = ({ enabled }) => {
  if (enabled) {
    return <Badge color="blue" label={'Enabled'} size="s" />;
  }

  return <Badge color={'gray'} label={'Disabled'} size="s" />;
};

export default EnabledDisabledBadge;
